import enCompanyTests from './en';
import ruCompanyTests from './ru';

export default {
  en: {
    ...enCompanyTests,
  },
  ru: {
    ...ruCompanyTests,
  },
};
